import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query'
import { ConsultationDataDto } from '~containers/app/ask-a-vet/types'
import Consultation from '~models/consultation'
import ConsultationRepository from '~repositories/impl/consultation-repository'
import { APP_QUERY_KEYS, MODEL_QUERY_KEYS } from './query-keys'

const useCreateConsultation = (
  options?: UseMutationOptions<Consultation.Level2, Error, ConsultationDataDto>
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: ConsultationRepository.createConsultation,
    onSuccess: (res, req, ctx) => {
      options?.onSuccess?.(res, req, ctx)

      /**
       * @TODO
       * invalidate 방식 말고, setQueryData 방식으로 데이터를 저장
       * 아래 paging 구조일 때는 Pending (Waiting) 상태 및 전체 패칭 대상으로만 업데이트하면 됨.
       */
      Object.entries(MODEL_QUERY_KEYS.consultation)
        .filter(([key]) => key !== 'all')
        .forEach(([, getQueryKey]) => {
          queryClient.setQueryData(getQueryKey(res.id), res)
        })
      queryClient.invalidateQueries({
        queryKey: APP_QUERY_KEYS.myConsultations,
      })
    },
  })
}

export default useCreateConsultation
